import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientUpdatesPage from "@/pages/client/ClientUpdatesPage";

export const Route = createFileRoute("/client/updates")({
  head: () => pageHead("Client · Updates", "AKIVA client · updates portal.", "/client/updates", true),
  component: ClientUpdatesPage,
});
